import React from 'react';
import { kdramas } from '../data/kdrama'; // Import the content data

function Review() {
  const starSVGs = {
    full: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="gold">
        <path d="M12 2l2.4 7.4h7.6l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4-6.2-4.5h7.6z" />
      </svg>
    ),
    half: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
        <defs>
          <linearGradient id="halfStarGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="50%" stopColor="gold" />
            <stop offset="50%" stopColor="#d3d3d3" />
          </linearGradient>
        </defs>
        <path d="M12 2l2.4 7.4h7.6l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4-6.2-4.5h7.6z" fill="url(#halfStarGradient)" />
      </svg>
    )
   
  };
  
  return (
    <div>
      <header className="page-header">
        <h1>The 10 Best K-Dramas You Shouldn't Miss</h1>
      </header>

      {kdramas.map((drama, index) => (
        <section key={index} className="review-section">
          <div className="review" >
            {/* Image of the K-Drama */}
            <img
              src={drama.imageUrl}
              alt={drama.title}
              className="kdrama-image"
            />
            {/* Review Content */}
            <div className="review-content">
            <h2>{drama.title}</h2>
            {/* Star Rating */}
            <div className="star-rating">
      {[...Array(5)].map((_, i) => {
        // Calculate if this should be a full, half, or empty star
        const fullStar = i < Math.floor(drama.rating);
        const halfStar = !fullStar && i < Math.floor(drama.rating + 0.5);
        
        // Choose which SVG to display
        let starType = 'empty';
        if (fullStar) starType = 'full';
        else if (halfStar) starType = 'half';
        
        return (
          <span key={i} className="star">
            {starSVGs[starType]}
          </span>
        );
      })}
    </div>
            <p className="text-container">{drama.description}</p>
            <a href= {drama.href} target="_blank" rel="noopener noreferrer" class="netflix-link">
  <img 
    src= {drama.whereToWatch} 
    alt= {drama.alt}
    width="100" 
    height="30"
  />
</a>
              
            
          </div>
        </div>
      </section>
      ))}
    </div>
  );
}

export default Review;
